import styled from 'styled-components';
import ArrowBack from '../../assets/onboarding/arrow-right-blue.svg';

const ArrowBlue = styled(ArrowBack as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '1.9rem'};
height: ${props => props.height || '2.4rem'};
display: flex;
`;

export default ArrowBlue;
